import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactPlayer from 'react-player'

import { playClicked } from '../../redux/actions';

import OverlayModal from '../molecules/modal/overlayModal';

class Video extends Component {
  render() {
    const { state } = this.props;
    return (
      <OverlayModal active={state ? 'active' : null } screen='video' >
        <ReactPlayer url='https://www.youtube.com/watch?v=in5e4a6oHFw' playing={this.props.state} />
      </OverlayModal>
    )
  }
}

function mapStateToProps(state) {
  return {
    state: state.overlays.video,
  };
}

export default connect(mapStateToProps, { playClicked })(Video);
